Ext.define('SA.AcsTable.EditView', {
    alias: 'widget.acs-edit-view',
    extend: 'SA.view.SimpleContainer',

    cls: 'sa-edit-view',

    items: [
        {
            xtype: 'simple-container',
            cls: 'sa-edit-header',

            items: [
                {
                    xtype: 'simple-container',
                    cls: 'sa-edit-header-upper',

                    items: [
                        {
                            xtype: 'component',
                            itemId: 'titleCmp',
                            cls: 'sa-edit-header-text'
                        }, {
                            xtype: 'sa-button',
                            itemId: 'doneBtn',
                            cls: 'sa-edit-header-done-btn',
                            text: 'Done',
                            ui: 'primary'
                        }
                    ]
                }, {
                    xtype: 'component',
                    itemId: 'messageCmp',
                    cls: 'sa-edit-header-warning',

                    tpl: [
                        '<svg class="sa-edit-header-warning-svg"><use href="#sa-icon-warning"></use></svg>',
                        '<div>{message}</div>'
                    ]
                }
            ]
        }, {
            xtype: 'simple-container',
            cls: 'sa-edit-view-sections-wrap',

            items: [
                {
                    xtype: 'simple-container',
                    cls: 'sa-edit-view-sections',

                    items: [
                        {
                            xtype: 'simple-container',
                            cls: 'sa-edit-panel',

                            items: [
                                {
                                    xtype: 'simple-container',
                                    cls: 'sa-edit-panel-header',

                                    items: [
                                        {
                                            xtype: 'component',
                                            cls: 'sa-edit-panel-header-title',
                                            html: 'Locations'
                                        }, {
                                            xtype: 'edit-panel-header-selection-buttons',
                                            itemId: 'selectionBtns'
                                        }
                                    ]
                                }, {
                                    xtype: 'simple-container',
                                    itemId: 'checkboxList',
                                    cls: 'sa-edit-panel-enabled-section'
                                }, {
                                    xtype: 'simple-container',
                                    itemId: 'unselectableLocationsSection',
                                    cls: 'sa-edit-panel-disabled-section',

                                    items: [
                                        {
                                            xtype: 'component',
                                            cls: 'sa-edit-panel-disabled-section-header',
                                            html: 'These locations are not supported by this view'
                                        }, {
                                            xtype: 'simple-container',
                                            cls: 'sa-edit-panel-disabled-section-body',
                                            itemId: 'unselectableLocationsList'
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                }
            ]
        }
    ]
});